let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6q2et")).then(() => parcelRequire('lxjSE'));